import React from "react";
import { Path } from "../Path";
import { useGameConventions } from "@seabrookstudios/pitch2table";
import { MenuItem } from "../core/MenuItem";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const ConventionsMenuItem = ({ gameId }) => {
  const { data: conventions = [] } = useGameConventions(gameId);

  const names = conventions.map((c) => c.name).join(", ");

  return (
    <MenuItem
      primary="Conventions"
      secondary={conventions.length === 0 ? "No conventions" : names}
      link={Path.game(gameId).conventions()}
    />
  );
};
